import { render, staticRenderFns } from "./InlineLabel.vue?vue&type=template&id=6f5c2251&scoped=true&"
import script from "./InlineLabel.vue?vue&type=script&lang=js&"
export * from "./InlineLabel.vue?vue&type=script&lang=js&"
import style0 from "./InlineLabel.vue?vue&type=style&index=0&id=6f5c2251&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c2251",
  null
  
)

export default component.exports